import { apiClient } from './apiClient';

const getExchanges = async (data) => {
  return await apiClient.get('/exchanges', data);
};

const getWeGoldExchanges = async (id, data) => {
  return await apiClient.get(`/exchanges/received/${id}`, data);
};

const getExchangesEdit = async (id, data) => {
  return await apiClient.get(`/exchanges/edit/${id}`, data);
};

const getExchangesGivenMerchant = async (data) => {
  return await apiClient.get(`/api/exchanges/typeGivenMerchant`, data);
};

const getExchangesReceivedMerchant = async (data) => {
  return await apiClient.get(`/api/exchanges/typeReceivedMerchant`, data);
};

const getExchangesCurrencyType = async (data) => {
  return await apiClient.get(`/api/exchanges/typeCurrency`, data);
};

const getExchangesCalculatingType = async (data) => {
  return await apiClient.get(`/api/exchanges/typeCalculating`, data);
};

const getExchangesParsers = async (data) => {
  return await apiClient.get(`/api/exchanges/parsers`, data);
};

const getStatuses = async (data) => {
  return await apiClient.get(`/api/statuses`, data);
};

const getGivenExchangesLabels = async (data) => {
  return await apiClient.get(`/labelsGiven`, data);
};

const getReceivedExchangesLabels = async (id, data) => {
  return await apiClient.get(`/labelsReceived/${id}`, data);
};

export const exchangesApi = {
  getExchanges,
  getWeGoldExchanges,
  getExchangesEdit,
  getExchangesGivenMerchant,
  getExchangesReceivedMerchant,
  getExchangesCurrencyType,
  getExchangesCalculatingType,
  getExchangesParsers,
  getStatuses,
  getGivenExchangesLabels,
  getReceivedExchangesLabels,
};
